import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App relative bg-background min-h-screen">
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(0 0% 100%)",
            color: "hsl(258 10% 38%)",
            border: "1px solid hsl(34 30% 78%)",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
